import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar11Colors = {
  background?: string;
  skin?: string;
  hair?: string;
  accessories?: string;
};

export const Avatar11 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar11Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar11" clipPath="url(#clip0_2446_10781)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M176.744 270.01c-1.811-3.273-.04-23.529.715-36.843 10.215-1.533 20.685 4.767 30.837-6.068 6.664-7.118 17.746-33.475 20.494-48.806 2.232-12.463-1.009-14.886-1.009-30.932 1.907-43.507-3.177-83.582-45.111-83.582-75.718 0-83.288 20.764-83.288 69.379 0 2.534-.421 1.589-.199 4.202-7.181 0-13.377 15.641-10.24 25.38 7.372 22.83 24.864 23.147 25.214 22.949 2.859 6.72-.374 52.944-2.272 60.649-3.066 12.447-26.397 22.981-26.397 22.981s22.012 17.746 46.994 33.116c6.331.803 12.79 1.224 19.343 1.224 15.109 0 29.693-2.217 43.459-6.323-.675-7.301-2.113-13.759-3.59-15.816-3.988-5.545-10.7-3.813-14.95-11.51Z"
          fill={c.skin}
        />
        <Path
          id="hair"
          d="M257.745 236.996c2.248-16.101-12.352-17.221-13.48-22.464-1.12-5.243 3.368-13.854 4.131-19.033.762-5.187-6.753-5.298-6.76-11.78 0-6.482 7.125-11.868 6.744-27.954-.374-16.085-13.481-26.873-13.481-26.873s2.248-3.09 2.248-20.311c0-17.222-16.475-32.942-31.019-47.543-14.545-14.6-53.071-13.702-53.071-13.702s3.32-5.315 3.32-8.198c0-2.884-3.765-3.988-3.765-3.988s.445-8.42-4.996-13.297c-5.442-4.878-11.407-.445-11.407-.445s-1.994-5.982-12.631-7.753c-10.636-1.771-16.308 3.543-16.308 3.543s-10.064-1.112-16.49 1.771c-6.427 2.884-9.97 10.192-9.97 10.192s-2.661-1.104-5.981 3.106-.223 11.963-.223 11.963-3.543 0-6.871 6.87c-3.32 6.872 2.637 16.881 2.637 16.881s-.357 4.687 2.16 9.008c2.527 4.321 13.275 3.241 13.275 3.241s-14.712 18.016-18.318 27.747c-3.607 9.731-2.16 32.219-2.16 32.219s-12.25 3.455-19.097 18.715c-6.848 15.26 2.883 37.351 2.16 40.576-.723 3.225-14.417 11.184-20.176 27.397-1.541 4.337-1.843 7.896-1.47 11.01a152.645 152.645 0 0 0 40.052 39.726 6470.05 6470.05 0 0 1 19.009-8.309c23.354-10.176 28.43-16.158 28.438-40.274.151-1.867.293-3.813.429-5.791 1.803-14.648 8.158-37.422-3.361-39.535-13.186-2.423-20.256-16.284-22.702-23.958-.874-6.633 1.533-14.727 5.234-19.144.016-.024.04-.04.056-.063.08-.096.167-.183.246-.279 1.462-1.588 3.082-2.653 4.727-2.875.206-.024.42-.04.627-.04 11.201 0 18.644 19.645 18.644 19.645s6.013-4.409 7.213-16.102c1.199-11.693-1.605-18.826-1.605-18.826s7.38 2.073 14.759 0c7.38-2.074 5.537-10.613 4.846-17.301-.691-6.689 5.997-11.765 5.997-11.765l-15.22-12.916s14.068 7.38 19.144 7.61c5.076.23 13.147-4.846 20.066-7.61 6.919-2.764 13.377 0 13.377 0s-3.75-10.215-7.213-15.18c6.275.373 11.494 14.711 11.494 14.711s8.603.612 20.066 10.438c10.326 8.857 16.546 36.858 17.341 46.732a340.903 340.903 0 0 1-.31 10.557c0 7.181.651 11.63 1.167 15.474.247 4.695.453 8.834.453 11.074-.063.659-.143 1.35-.238 2.073-4.48 24.959-25.062 54.707-26.007 55.239-15.276 2.344-26.103 1.438-26.103 1.438l-1.533 20.86c-.071 1.501.024 17.055.024 17.055s4.242 7.3 9.516 8.77c3.495.977 14.037 6.41 24.824 12.701a151.864 151.864 0 0 0 38.423-23.219c-1.009-1.803-1.74-2.986-1.74-2.986s8.611-12.726 10.859-28.828Z"
          fill={c.hair}
        />
        <Path
          id="Vector"
          d="M139.886 133.666s13.202-4.146 23.457-4.075c12.058.088 20.534 8.158 22.854 4.028.738-1.311.238-8.214-21.742-10.478-9.834-1.017-15.625 3.606-24.569 10.525Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M182.805 151.238c-2.97-5.084-7.903-9.771-14.091-10.907-2.789-.325-5.609-.016-8.262 1.017-2.168.826-3.844 2.2-5.449 3.575-2.184 1.509-5.076.929-7.697.627 2.478 1.732 6.14 3.122 9.151 1.637a26.983 26.983 0 0 1 2.097-1.224 5.958 5.958 0 0 0-.048.66c0 4.043 3.392 7.324 7.57 7.324 4.179 0 7.571-3.281 7.571-7.324 0-.334-.032-.652-.072-.977 2.963 1.358 5.95 3.376 9.23 5.592Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          opacity={0.75}
          d="M205.246 136.113c-.286-.405-.278-1.073.087-1.867-10.342 14.839 3.941 38.717-1.628 43.221-3.892 3.146-18.604-1.247-19.176 2.772 5.354 3.384 20.105 6.085 24.57-1.739 1.747-4.036-9.819-30.901 1.652-42.403-2.169 1.549-4.544 1.382-5.505.016Z"
          fill="#2E2017"
        />
        <Path
          id="Vector_4"
          opacity={0.75}
          d="M143.627 232.985c14.513 12.709 22.782 16.57 32.14 17.579-.175-7.451 1.692-17.77 1.279-17.913-20.638-7.308-29.622-13.997-46.375-28.795-6.1-5.386-9.619-13.171-14.338-20.28 0 .468-1.446 1.056-1.962 2.764 2.351 10.493 9.207 29.089 29.248 46.637l.008.008Z"
          fill="#2E2017"
        />
        <Path
          id="Vector_5"
          opacity={0.75}
          d="M168.888 194.292c.897.778 13.432 15.037 27.476 14.513 11.964-.445 15.832-12.17 16.118-12.766 0 0-5.29-5.06-8.96-4.925-3.678.136-6.244 1.955-6.244 1.955s-3.312-1.978-7.213-1.835c-3.908.143-7.379 2.184-11.033 2.796-3.694.619-10.136.262-10.136.262h-.008Zm5.052 2.28c-.103-.056-.008-.167.103-.127 4.472 1.604 12.233 2.7 24.26 2.256 6.196-.231 10.295-.429 13.686-1.557-3.376 1.398-7.832 5.155-14.02 5.385-12.058.445-19.605-3.582-24.029-5.957Z"
          fill="#2E2017"
        />
        <Path
          id="Vector_6"
          d="M227.996 125.58c-14.418-.429-24.299 7.562-22.75 10.533.961 1.835 3.9 1.914 6.068-.159 5.95-5.1 10.565-3.4 16.801-3.487.135-2.105-.095-5.132-.119-6.887Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M233.62 145.621c-1.605-1.374-3.281-2.748-5.449-3.574-2.654-1.025-5.474-1.343-8.262-1.017-6.188 1.136-11.121 5.822-14.092 10.906 1.684-1.136 3.289-2.224 4.854-3.193.286 3.559 3.36 6.355 7.109 6.355 3.94 0 7.142-3.09 7.142-6.903 0-1.295-.39-2.494-1.033-3.527 2.55.286 5.267 1.271 8.277 3.217 3.011 1.486 6.681.103 9.151-1.636-2.621.302-5.513.882-7.697-.628Z"
          fill="#000"
        />
        <Path
          id="accessories"
          d="M106.904 174.886c-7.228 0-13.09 11.017-13.09 24.609 0 13.591 5.862 24.609 13.09 24.609 7.229 0 13.091-11.018 13.091-24.609 0-13.592-5.862-24.609-13.091-24.609Zm.056 42.18c-4.893 0-8.865-7.467-8.865-16.673 0-9.207 3.972-16.674 8.865-16.674 4.893 0 8.865 7.467 8.865 16.674 0 9.206-3.972 16.673-8.865 16.673Z"
          fill={c.accessories}
        />
        <Path
          id="accessories_2"
          d="M223.151 213.841c0 9.206-3.471 16.673-7.745 16.673-2.598 0-5.108-3.01-6.514-7.221-.675.954-1.096 2.026-1.708 2.677-.389.414-.897 1.51-1.287 1.875 2.074 6.307 5.601 9.715 9.461 9.715 6.315 0 11.431-11.018 11.431-24.609 0-7.411-.802-13.17-3.209-17.682-.779 2.224-2.026 4.233-2.9 6.442 1.7 3.058 2.471 6.99 2.471 12.13Z"
          fill={c.accessories}
        />
        <G id="Group" fill="#000">
          <Path
            id="Vector_8"
            d="M85.489 269.327c-1.366.444-12.885.58-25.848 3.145 20.764 15.895 45.747 26.548 72.977 29.987-22.568-13.869-42.871-29.748-47.137-33.132h.008Z"
          />
          <Path
            id="Vector_9"
            d="M192.171 282.33c1.311 2.645 2.518 8.492 3.122 15.013a149.41 149.41 0 0 0 14.91-5.314c-5.775-3.368-11.471-6.49-16.062-8.809-.651-.294-1.303-.596-1.97-.89Z"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_2446_10781">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
